import { Box, MenuItem } from '@mui/material';
import { Replay as ResetIcon } from '@mui/icons-material';
import {
  CustomButton,
  CustomSelect,
  CustomTextField,
  HorizontalForm,
} from '../../../common/components';
import { AUDIT_HTTP_METHODS, DATE_INPUT_FORMAT } from '../constants/auditConstants';

const AuditFilters = ({
  modules = [],
  users = [],
  filters,
  onFilterChange,
  onReset,
  usersLoading = false,
}) => {
  return (
    <Box sx={{ mt: 0 }}>
      <HorizontalForm variant="twoRows">
        <CustomSelect
          label="Módulo"
          value={filters.moduleKey}
          onChange={(event) => onFilterChange('moduleKey', event.target.value)}
          sx={{ maxWidth: 300, mr: 2 }}
        >
          <MenuItem value="">Todos</MenuItem>
          {modules.map((module) => (
            <MenuItem key={module.key || module.id} value={module.key}>
              {module.display_name || module.key}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label="Usuario"
          value={filters.userUuid}
          onChange={(event) => onFilterChange('userUuid', event.target.value)}
          sx={{ maxWidth: 300, mr: 2 }}
          disabled={usersLoading}
        >
          <MenuItem value="">Todos</MenuItem>
          {users.map((user) => (
            <MenuItem key={user.uuid} value={user.uuid}>
              {user.names || user.email || user.uuid}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label="Método HTTP"
          value={filters.httpMethod}
          onChange={(event) => onFilterChange('httpMethod', event.target.value)}
          sx={{ maxWidth: 300, mr: 2 }}
        >
          <MenuItem value="">Todos</MenuItem>
          {AUDIT_HTTP_METHODS.map((method) => (
            <MenuItem key={method} value={method}>
              {method}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomTextField
          label="Buscar en descripción o detalles"
          value={filters.search}
          onChange={(event) => onFilterChange('search', event.target.value)}
          size="medium"
          sx={{ maxWidth: 300, mr: 2 }}
        />

        <CustomTextField
          label="Endpoint"
          value={filters.endpoint}
          onChange={(event) => onFilterChange('endpoint', event.target.value)}
          size="medium"
          sx={{ maxWidth: 300, mr: 2 }}
        />

        <CustomTextField
          label="Desde"
          type="date"
          value={filters.startDate}
          onChange={(event) => onFilterChange('startDate', event.target.value)}
          size="medium"
          shrinkLabel
          inputProps={{ max: filters.endDate || undefined, pattern: DATE_INPUT_FORMAT }}
          sx={{ maxWidth: 300, mr: 2 }}
        />

        <CustomTextField
          label="Hasta"
          type="date"
          value={filters.endDate}
          onChange={(event) => onFilterChange('endDate', event.target.value)}
          size="medium"
          shrinkLabel
          inputProps={{ min: filters.startDate || undefined, pattern: DATE_INPUT_FORMAT }}
          sx={{ maxWidth: 300, mr: 2 }}
        />

        <CustomButton variant="warning" buttonIcon={ResetIcon} onClick={onReset} sx={{ mt: 1.5, minWidth: 300 }}>
          Limpiar filtros
        </CustomButton>
      </HorizontalForm>
    </Box>
  );
};

export default AuditFilters;
